import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import {
  eqVisibleColumns,
  tsuVisibleColumns,
  refVisibleColumns,
  volLocVisibleColumns,
  eqSort,
  tsuSort,
  refSort,
  volLocSort,
} from '../../../EditReduxConstant';

export const CLEAR_EDIT_VOLCANO_EVENT = 'CLEAR_EDIT_VOLCANO_EVENT';

export const GET_EDIT_VOLCANO_EVENT_REQUEST = 'GET_EDIT_VOLCANO_EVENT_REQUEST';
export const GET_EDIT_VOLCANO_EVENT_SUCCESS = 'GET_EDIT_VOLCANO_EVENT_SUCCESS';
export const GET_EDIT_VOLCANO_EVENT_FAILURE = 'GET_EDIT_VOLCANO_EVENT_FAILURE';

export const UPDATE_EDIT_VOLCANO_EVENT_REQUEST = 'UPDATE_EDIT_VOLCANO_EVENT_REQUEST';
export const UPDATE_EDIT_VOLCANO_EVENT_SUCCESS = 'UPDATE_EDIT_VOLCANO_EVENT_SUCCESS';
export const UPDATE_EDIT_VOLCANO_EVENT_FAILURE = 'UPDATE_EDIT_VOLCANO_EVENT_FAILURE';

export const CREATE_EDIT_VOLCANO_EVENT_REQUEST = 'CREATE_EDIT_VOLCANO_EVENT_REQUEST';
export const CREATE_EDIT_VOLCANO_EVENT_SUCCESS = 'CREATE_EDIT_VOLCANO_EVENT_SUCCESS';
export const CREATE_EDIT_VOLCANO_EVENT_FAILURE = 'CREATE_EDIT_VOLCANO_EVENT_FAILURE';


export const EDIT_VOLCANO_EVENT_LOCATION_REQUEST = 'EDIT_VOLCANO_EVENT_LOCATION_REQUEST';
export const EDIT_VOLCANO_EVENT_LOCATION_SUCCESS = 'EDIT_VOLCANO_EVENT_LOCATION_SUCCESS';
export const EDIT_VOLCANO_EVENT_LOCATION_FAILURE = 'EDIT_VOLCANO_EVENT_LOCATION_FAILURE';

export const EDIT_VOLCANO_EVENT_LOCATION_SEARCH_REQUEST = 'EDIT_VOLCANO_EVENT_LOCATION_SEARCH_REQUEST';
export const EDIT_VOLCANO_EVENT_LOCATION_SEARCH_SUCCESS = 'EDIT_VOLCANO_EVENT_LOCATION_SEARCH_SUCCESS';
export const EDIT_VOLCANO_EVENT_LOCATION_SEARCH_FAILURE = 'EDIT_VOLCANO_EVENT_LOCATION_SEARCH_FAILURE';

export const EDIT_VOLCANO_EVENT_EARTHQUAKE_REQUEST = 'EDIT_VOLCANO_EVENT_EARTHQUAKE_REQUEST';
export const EDIT_VOLCANO_EVENT_EARTHQUAKE_SUCCESS = 'EDIT_VOLCANO_EVENT_EARTHQUAKE_SUCCESS';
export const EDIT_VOLCANO_EVENT_EARTHQUAKE_FAILURE = 'EDIT_VOLCANO_EVENT_EARTHQUAKE_FAILURE';

export const EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_REQUEST = 'EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_REQUEST';
export const EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_SUCCESS = 'EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_SUCCESS';
export const EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_FAILURE = 'EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_FAILURE';

export const EDIT_VOLCANO_EVENT_REFERENCE_REQUEST = 'EDIT_VOLCANO_EVENT_REFERENCE_REQUEST';
export const EDIT_VOLCANO_EVENT_REFERENCE_SUCCESS = 'EDIT_VOLCANO_EVENT_REFERENCE_SUCCESS';
export const EDIT_VOLCANO_EVENT_REFERENCE_FAILURE = 'EDIT_VOLCANO_EVENT_REFERENCE_FAILURE';

export const EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_REQUEST = 'EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_REQUEST';
export const EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_SUCCESS = 'EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_SUCCESS';
export const EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_FAILURE = 'EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_FAILURE';


export const EDIT_VOLCANO_EVENT_TSUNAMI_REQUEST = 'EDIT_VOLCANO_EVENT_TSUNAMI_REQUEST';
export const EDIT_VOLCANO_EVENT_TSUNAMI_SUCCESS = 'EDIT_VOLCANO_EVENT_TSUNAMI_SUCCESS';
export const EDIT_VOLCANO_EVENT_TSUNAMI_FAILURE = 'EDIT_VOLCANO_EVENT_TSUNAMI_FAILURE';

export const EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_REQUEST = 'EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_REQUEST';
export const EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_SUCCESS = 'EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_SUCCESS';
export const EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_FAILURE = 'EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_FAILURE';


export const EDIT_VOLCANO_EVENT_AGENT_REQUEST = 'EDIT_VOLCANO_EVENT_AGENT_REQUEST';
export const EDIT_VOLCANO_EVENT_AGENT_SUCCESS = 'EDIT_VOLCANO_EVENT_AGENT_SUCCESS';
export const EDIT_VOLCANO_EVENT_AGENT_FAILURE = 'EDIT_VOLCANO_EVENT_AGENT_FAILURE';

export const EDIT_VOLCANO_EVENT_REFERENCE_SORT = 'EDIT_VOLCANO_EVENT_REFERENCE_SORT';
export const EDIT_VOLCANO_EVENT_TSUNAMI_SORT = 'EDIT_VOLCANO_EVENT_TSUNAMI_SORT';
export const EDIT_VOLCANO_EVENT_EARTHQUAKE_SORT = 'EDIT_VOLCANO_EVENT_EARTHQUAKE_SORT';
export const EDIT_VOLCANO_EVENT_LOCATION_SORT = 'EDIT_VOLCANO_EVENT_LOCATION_SORT';

export const EDIT_VOLCANO_EVENT_OPEN_CONFIRMATION = 'EDIT_VOLCANO_EVENT_OPEN_CONFIRMATION';
export const EDIT_VOLCANO_EVENT_CANCEL_CONFIRMATION = 'EDIT_VOLCANO_EVENT_CANCEL_CONFIRMATION';

export const EDIT_VOLCANO_EVENT_EARTHQUAKE_TOGGLE_COLUMN = 'EDIT_VOLCANO_EVENT_EARTHQUAKE_TOGGLE_COLUMN';
export const EDIT_VOLCANO_EVENT_TSUNAMI_TOGGLE_COLUMN = 'EDIT_VOLCANO_EVENT_TSUNAMI_TOGGLE_COLUMN';
export const EDIT_VOLCANO_EVENT_REFERENCE_TOGGLE_COLUMN = 'EDIT_VOLCANO_EVENT_REFERENCE_TOGGLE_COLUMN';
export const EDIT_VOLCANO_EVENT_VOLLOC_TOGGLE_COLUMN = 'EDIT_VOLCANO_EVENT_VOLLOC_TOGGLE_COLUMN';

const initialState = fromJS({
  fetched: false,
  volcanoEvent: {
    referenceIds: [],
  },
  updating: false,

  volcanoLocation: {},
  fetchedVolcanoLocation: false,
  volcanoLocationSearchResults: [],
  locationSearching: false,

  earthquake: [],
  fetchedEarthquake: false,
  earthquakeSearchResults: [],
  earthquakeSearching: false,

  references: [],
  fetchedReferences: false,
  referenceSearchResults: [],
  referenceSearching: false,

  tsunami: [],
  fetchedTsunami: false,
  tsunamiSearchResults: [],
  tsunamiSearching: false,

  fetchedAgents: false,
  agents: [],


  tsuSort,
  eqSort,
  refSort,
  volLocSort,

  formData: {},
  editConfirmationOpen: false,

  eqVisibleColumns,
  tsuVisibleColumns,
  refVisibleColumns,
  volLocVisibleColumns,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const editVolcanoEventReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EDIT_VOLCANO_EVENT:
      return initialState;


    case EDIT_VOLCANO_EVENT_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        editConfirmationOpen: true,
      }));
    case EDIT_VOLCANO_EVENT_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        editConfirmationOpen: false,
      }));

    case GET_EDIT_VOLCANO_EVENT_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));
    case CREATE_EDIT_VOLCANO_EVENT_REQUEST:
    case UPDATE_EDIT_VOLCANO_EVENT_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: true,
      }));
    case CREATE_EDIT_VOLCANO_EVENT_SUCCESS:
    case UPDATE_EDIT_VOLCANO_EVENT_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        volcanoEvent: action.response,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_VOLCANO_EVENT_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        volcanoEvent: action.response,
        updating: false,
      }));
    case CREATE_EDIT_VOLCANO_EVENT_FAILURE:
    case UPDATE_EDIT_VOLCANO_EVENT_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_VOLCANO_EVENT_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));


    case EDIT_VOLCANO_EVENT_LOCATION_SORT:
      return state.merge(fromJS({
        volcanoLocationSearchResults: basicSort(action.sort, state.get('volcanoLocationSearchResults')),
        volLocSort: action.sort,
      }));

    case EDIT_VOLCANO_EVENT_LOCATION_REQUEST:
      return state.merge(fromJS({
        fetchedVolcanoLocation: false,
      }));
    case EDIT_VOLCANO_EVENT_LOCATION_SUCCESS:
      return state.merge(fromJS({
        fetchedVolcanoLocation: true,
        volcanoLocation: action.response,
      }));
    case EDIT_VOLCANO_EVENT_LOCATION_FAILURE:
      return state.merge(fromJS({
        fetchedVolcanoLocation: true,
      }));

    case EDIT_VOLCANO_EVENT_LOCATION_SEARCH_REQUEST:
      return state.merge(fromJS({
        locationSearching: true,
      }));
    case EDIT_VOLCANO_EVENT_LOCATION_SEARCH_SUCCESS:
      return state.merge(fromJS({
        locationSearching: false,
        volcanoLocationSearchResults: basicSort(state.get('volLocSort'), fromJS(action.response.items)),
      }));
    case EDIT_VOLCANO_EVENT_LOCATION_SEARCH_FAILURE:
      return state.merge(fromJS({
        locationSearching: false,
      }));


    case EDIT_VOLCANO_EVENT_EARTHQUAKE_SORT:
      return state.merge(fromJS({
        earthquakeSearchResults: basicSort(action.sort, state.get('earthquakeSearchResults')),
        eqSort: action.sort,
      }));

    case EDIT_VOLCANO_EVENT_EARTHQUAKE_REQUEST:
      return state.merge(fromJS({
        fetchedEarthquake: false,
      }));
    case EDIT_VOLCANO_EVENT_EARTHQUAKE_SUCCESS:
      return state.merge(fromJS({
        fetchedEarthquake: true,
        earthquake: action.response.items,
      }));
    case EDIT_VOLCANO_EVENT_EARTHQUAKE_FAILURE:
      return state.merge(fromJS({
        fetchedEarthquake: true,
      }));

    case EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_REQUEST:
      return state.merge(fromJS({
        earthquakeSearching: true,
      }));
    case EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_SUCCESS:
      return state.merge(fromJS({
        earthquakeSearching: false,
        earthquakeSearchResults: basicSort(state.get('eqSort'), fromJS(action.response.items)),
      }));
    case EDIT_VOLCANO_EVENT_EARTHQUAKE_SEARCH_FAILURE:
      return state.merge(fromJS({
        earthquakeSearching: false,
      }));


    case EDIT_VOLCANO_EVENT_REFERENCE_SORT:
      return state.merge(fromJS({
        referenceSearchResults: basicSort(action.sort, state.get('referenceSearchResults')),
        refSort: action.sort,
      }));

    case EDIT_VOLCANO_EVENT_REFERENCE_REQUEST:
      return state.merge(fromJS({
        fetchedReferences: false,
      }));
    case EDIT_VOLCANO_EVENT_REFERENCE_SUCCESS:
      return state.merge(fromJS({
        fetchedReferences: true,
        references: action.response.items,
      }));
    case EDIT_VOLCANO_EVENT_REFERENCE_FAILURE:
      return state.merge(fromJS({
        fetchedReferences: true,
      }));

    case EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_REQUEST:
      return state.merge(fromJS({
        referenceSearching: true,
      }));
    case EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_SUCCESS:
      return state.merge(fromJS({
        referenceSearching: false,
        referenceSearchResults: basicSort(state.get('refSort'), fromJS(action.response.items)),
      }));
    case EDIT_VOLCANO_EVENT_REFERENCE_SEARCH_FAILURE:
      return state.merge(fromJS({
        referenceSearching: false,
      }));


    case EDIT_VOLCANO_EVENT_TSUNAMI_SORT:
      return state.merge(fromJS({
        tsunamiSearchResults: basicSort(action.sort, state.get('tsunamiSearchResults')),
        tsuSort: action.sort,
      }));

    case EDIT_VOLCANO_EVENT_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetchedTsunami: false,
      }));
    case EDIT_VOLCANO_EVENT_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetchedTsunami: true,
        tsunami: action.response.items,
      }));
    case EDIT_VOLCANO_EVENT_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetchedTsunami: true,
      }));

    case EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_REQUEST:
      return state.merge(fromJS({
        tsunamiSearching: true,
      }));
    case EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_SUCCESS:
      return state.merge(fromJS({
        tsunamiSearching: false,
        tsunamiSearchResults: basicSort(state.get('tsuSort'), fromJS(action.response.items)),
      }));
    case EDIT_VOLCANO_EVENT_TSUNAMI_SEARCH_FAILURE:
      return state.merge(fromJS({
        tsunamiSearching: false,
      }));

    case EDIT_VOLCANO_EVENT_AGENT_REQUEST:
      return state.merge(fromJS({
        fetchedAgents: false,
      }));
    case EDIT_VOLCANO_EVENT_AGENT_SUCCESS:
      return state.merge(fromJS({
        fetchedAgents: true,
        agents: action.response.items,
      }));
    case EDIT_VOLCANO_EVENT_AGENT_FAILURE:
      return state.merge(fromJS({
        fetchedAgents: true,
      }));

    case EDIT_VOLCANO_EVENT_EARTHQUAKE_TOGGLE_COLUMN:
      return state.merge(fromJS({
        eqVisibleColumns: action.visibleColumns,
      }));

    case EDIT_VOLCANO_EVENT_TSUNAMI_TOGGLE_COLUMN:
      return state.merge(fromJS({
        tsuVisibleColumns: action.visibleColumns,
      }));

    case EDIT_VOLCANO_EVENT_REFERENCE_TOGGLE_COLUMN:
      return state.merge(fromJS({
        refVisibleColumns: action.visibleColumns,
      }));

    case EDIT_VOLCANO_EVENT_VOLLOC_TOGGLE_COLUMN:
      return state.merge(fromJS({
        volLocVisibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
